import React, { useState, useEffect } from "react";

function IsOnline() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showOnlineMessage, setShowOnlineMessage] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowOnlineMessage(true);
    };

    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  useEffect(() => {
    if (showOnlineMessage && isOnline) {
      const timer = setTimeout(() => setShowOnlineMessage(false), 5000);
      return () => clearTimeout(timer);
    }
  }, [showOnlineMessage, isOnline]);

  if (!isOnline) {
    return (
      <div className="d-flex justify-content-center align-items-center bg-danger text-white p-2">
        <i className="fas fa-exclamation-circle" aria-hidden="true" />
        <span className="ml-2">
          You are currently offline. Please check your internet connection and
          try again.
        </span>
      </div>
    );
  }

  if (showOnlineMessage) {
    return (
      <div className="d-flex justify-content-between align-items-center bg-success text-white p-2">
        <div/>
        <div>
          <i className="fas fa-check-circle" aria-hidden="true" />
          <span className="ml-2">
            You are back online. Your internet connection has been restored.
          </span>
        </div>
        <button
          className="btn btn-link text-white p-0 mr-2"
          onClick={() => setShowOnlineMessage(false)}
        >
          <i className="fas fa-times" style={{fontSize: "small"}} aria-hidden="true" />
        </button>
      </div>
    );
  }

  return null;
}

export default IsOnline;
